import { classNames } from 'primereact/utils';
import {
  CarouselContext,
  CarouselPassThroughOptions,
  CarouselProps,
} from 'primereact/carousel';

export const PTCarousel: CarouselPassThroughOptions = {
  root: {
    className: 'flex flex-col h-full',
  },
  content: {
    className: 'flex flex-col overflow-auto h-full justify-between',
  },
  container: ({ props }: { props: CarouselProps }) => ({
    className: classNames('flex', {
      'flex-row': props.orientation !== 'vertical',
      'flex-col': props.orientation === 'vertical',
    }),
  }),
  previousButton: {
    className: classNames(
      'flex justify-center items-center self-center overflow-hidden relative shrink-0 grow-0',
      'w-8 h-8 text-gray-700 border-0 bg-transparent rounded-full transition duration-200 ease-in-out mx-2',
    ),
  },
  nextButton: {
    className: classNames(
      'flex justify-center items-center self-center overflow-hidden relative shrink-0 grow-0',
      'w-8 h-8 text-gray-700 border-0 bg-transparent rounded-full transition duration-200 ease-in-out mx-2',
    ),
  },
  itemsContent: {
    className: 'overflow-hidden w-full',
  },
  itemCloned: ({ props }: { props: CarouselProps }) => ({
    className: classNames('flex shrink-0 grow', {
      [`w-1/${props.numVisible}`]:
        props.orientation !== 'vertical' && props.numVisible !== 1,
      'w-full': props.orientation === 'vertical' || props.numVisible === 1,
    }),
  }),
  itemsContainer: ({ props }: { props: CarouselProps }) => ({
    className: classNames('flex', {
      'flex-row': props.orientation !== 'vertical',
      'flex-col h-full': props.orientation === 'vertical',
    }),
  }),
  item: ({ props }: { props: CarouselProps }) => ({
    className: classNames('flex shrink-0 grow mx-px', {
      [`w-1/${props.numVisible}`]:
        props.orientation !== 'vertical' && props.numVisible !== 1,
      'w-full': props.orientation === 'vertical' || props.numVisible === 1,
    }),
  }),
  indicators: {
    className: classNames('flex flex-row justify-center flex-wrap'),
  },
  indicator: {
    className: 'mr-2',
  },
  indicatorButton: ({ context }: { context: CarouselContext }) => ({
    className: classNames('ax-carousel__indicator-button', {
      'ax-carousel__indicator-button--active': context.active,
    }),
  }),
};
